import request from './request'

// 发送短信验证码
export const sendSmsCode = (phone) => {
  return request.post('/auth/sms-code', { phone })
}

// 用户名密码登录
export const login = (data) => {
  return request.post('/auth/login/', data)
}

// 短信验证码登录 (保留兼容性)
export const loginBySms = (data) => {
  return request.post('/auth/login/sms', data)
}

// 获取用户信息
export const getUserInfo = () => {
  return request.get('/auth/profile')
}

// 修改密码
export const changePassword = (data) => {
  return request.post('/auth/change-password', data)
}
